<li class="mb-2 p-2 rounded friend-item d-flex align-items-center cursor-pointer position-relative overflow-hidden"
    (contextmenu)="contextMenu.open($event)" (dblclick)="onDblClick()" (mouseleave)="closeSwipe()"
    (pointerdown)="onPointerDown($event)" (pointermove)="onPointerMove($event)" (pointerup)="onPointerUp($event)"
    [class.swiped-open]="isSwipedOpen()" [class.has-nameplate]="player().backgroundUrl"
    [class]="'friend-status-' + getStatusText(player().status)" [style]="player().backgroundUrl">

    <div class="position-relative me-3 flex-shrink-0">
        <img [src]="'https://static.h5arena.com/images/avatars/' + getFriendPortrait(player().portraitId)()"
            class="rounded-circle" width="40" height="40" alt="avatar">
        <span class="status-dot" [class]="'status-dot-' + getStatusText(player().status)"></span>
    </div>

    <div class="flex-grow-1 text-truncate">
        <div class="fw-bold d-flex align-items-center gap-1"
            [style.color]="player().userNameColor ? player().userNameColor : 'rgb(108, 117, 125)'">
            <span>{{ player().userName }}</span>
            @if(isParentLobbyOwner()) {
            <i class="fas fa-feather-alt small ms-auto text-white" title="Lobby Owner"></i>
            }
            @if(isModerator()) {
            <img src="/images/moderator_icon.png" class="moderator-icon" width="16" height="16" alt="Moderator"
                title="Room Moderator">
            }
        </div>
        <small class="d-flex align-items-center gap-1 text-truncate" [class.text-white]="player().isTalking"
            [class.text-muted]="!player().isTalking" style="font-size: 0.8rem;">
            @if(activeIconUrl(); as iconUrl) {
            <img [src]="iconUrl" class="user-icon" width="24" height="24" [alt]="activeIconDescription() || 'User Icon'"
                [title]="activeIconDescription() || 'User Icon'">
            }
            <span>{{ player().isTalking ? 'is talking' : getStatusText(player().status) }}</span>
        </small>
    </div>

    @if(canDelete) {
    <button class="remove-btn" [class.confirm-active]="confirmDeleteActive()" (click)="onDeleteClick($event)"
        title="Remove Friend">
        {{ confirmDeleteActive() ? 'Confirm' : 'Delete' }}
    </button>
    }
</li>

<app-player-context-menu #contextMenu [player]="player()" [isFriend]="isFriend()" [isLobbyOwner]="isLobbyOwner()"
    [isFriendList]="canDelete" (action)="handleContextMenuAction($event)">
</app-player-context-menu>